<template>
  <div class="bodybox">
    <div class="columnBox">
      <div class="columnBoxInnner">
        <div class="columnBoxInnnerList">
          <div v-for="(item,index) in columnlist" :key="index" :class="currrentcolumn==index?'activename':'column_a'" @click="changeNowColumn(item.value,index)">
            <span class="nameshow">{{ item.name }}</span><span v-show="index<columnlist.length-1" class="a_span">/</span>
          </div>
        </div>
      </div>
      <div class="centerBox">
        <div v-for="(item1,index) in currentData" :key="index" class="centerli" @click="goDetail(item1.CONTENT_ID)">
          <div class="topColumnname" @click="goColumn(item1.COLUMN_ID,item1.COLUMN_NAME)">
            {{ item1.COLUMN_NAME }}
          </div>
          <div class="imgbox">
            <img v-if="item1.CONTENT_PHOTO_SMALL" :src="item1.CONTENT_PHOTO_SMALL" alt="">
            <img v-else :src="noIMG" alt="">
          </div>
          <p class="centerli_p">
            <span class="titlename">{{ item1.CONTENT_TITLE }}</span>
            <span class="hot_time">    {{ item1.CONTENT_ISSUE_DATE|changeTime }}</span>
            <span class="el-icon-view viewNumber">    {{ item1.CONTENT_READING_SIZE|changenum }}</span>
            <span class="viewNumber">
              <svg-icon icon-class="pinlun" />
              {{ item1.CONTENT_SPEAK_NUMBER|changenum }}
            </span>
          </p>
        </div>
      </div>
      <div v-if="loadAll" class="atfoot loadMore">
        已经到底部了
      </div>
      <div v-else class="loadMore" @click="addMore">
        加载更多>>
      </div>
    </div>
  </div>
</template>
<script>
import { getColumnData } from '@/api/api.js'
export default {
  props: ['columnlist', 'initdata', 'alldata', 'columnName'],
  data() {
    return {
      currentPage: 1,
      currrentcolumn: 0,
      loadAll: false,
      page: 1,
      currentData: this.initdata,
      templateId: '',
      noIMG: require('@/static/home_noimg.png')

    }
  },
  computed: {

  },
  created() {

  },
  mounted() {
    console.log(this.currentData)
    this.page = this.alldata.page
    if (this.page === this.currentPage * 1) {
      this.loadAll = true
    }
  },
  methods: {
    changeNowColumn: function(ID, index) {
      this.loadAll = false
      var obj = {}
      obj.columnId = this.columnName
      obj.index = '1'
      obj.size = '9'
      if (ID) {
        obj.templateId = ID
      }
      this.currentPage = 1
      this.currrentcolumn = index
      getColumnData(obj).then(res => {
        this.currentData = []
        if (res.data) {
          this.currentData = this.currentData.concat(res.data.listMapData)
          if (res.data.page == 0) {
            this.page = 1
          } else {
            this.page = res.data.page
          }
          if (this.currentPage <= this.page) {
            this.loadAll = true
          }
        } else {
          this.loadAll = true
        }
      })
    },
    // /加载更多
    addMore: function() {
      var obj = {}
      obj.columnId = this.columnName
      if (this.templateId) {
        obj.templateId = this.templateId
      }
      obj.index = this.currentPage + 1
      obj.size = '9'
      getColumnData(obj).then(res => {
        this.currentData = this.currentData.concat(res.data.listMapData)
        this.currentPage += 1
        if (this.currentPage >= this.page) {
          this.loadAll = true
        }
      })
    },
    goDetail: function(contentId) {
      const { href } = this.$router.resolve({
        path: '/Detail',
        name: 'dt',
        query: {
          contentId
        }
      })
      window.open(href, '_blank')
    },
    goColumn: function(contentId, name) {
      window.location.href = '/column/?columnId=' + contentId
    }
  }

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .bodybox{
        background-color: #fafafa;
    }
    .columnBox{
        text-align: center;
        .activename{
            display: inline-block;
            cursor: pointer;
            .a_span{
                margin: 0 16px;
            }
            .nameshow{
                color: #ed4040;
                font-size: 16px;
                font-weight: 600;
            }

        }
        .column_a{
            display: inline-block;
            cursor: pointer;
            font-size: 16px;
            .a_span{
                margin: 0 16px;
            }
            .nameshow{
                font-size: 16px;
                color: #333333;
              font-weight: 600;
                &:hover{
                    color: #ed4040;
                }
            }
        }
        .loadMore{
          height: 45px;
          line-height: 45px;
          font-size: 14px;
          color: #999999;
          background-color: #fff;
          border: 1px solid #e5e5e5;
          border-radius: 3px;
          cursor: pointer;
          display: inline-block;
          width: 100%;
          margin-top: 20px;
          transition: 0.5s;
          text-align: center;
          margin-bottom: 60px;
          &:hover{
            border: 1px solid #E3003A;
            color: #E3003A;
          }
        }
        .atfoot{
            cursor: auto;
        }
    }
    .centerBox{
        font-size: 0;
        text-align: left;
        .centerli{
            width: 267px;
            height: 278px;
            display: inline-block;
            margin-right: 39px;
            margin-top:20px;
            position: relative;
            background-color: #fff;
            .centerli_p{
                margin-top: -4px;
                width: 256px;
                height: 93px;
                border-left: 1px solid #f0f0f0;
                border-right: 1px solid #f0f0f0;
                border-bottom: 1px solid #f0f0f0;
                -moz-box-shadow:1px 1px 3px #f3f3f3;
                -webkit-box-shadow:1px 1px 3px #f3f3f3;
                box-shadow:1px 1px 3px #f3f3f3;
                text-align: left;
                padding-left: 9px;
              svg{
                color: #bfbfbf;
              }
                .titlename {
                    color: #333333;
                    font-size: 14px;
                    font-weight: 500;
                    display: inline-block;
                    padding-top: 8px;
                    height: 55px;
                    line-height: 25px;
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                }
        }
        .centerli:nth-child(3n){
        margin-right: 0;
      }
    }
    .topColumnname{
        position: absolute;
        top:10px;
        left: 10px;
      padding: 0 5px;
        background-color:rgba(51,51,51,.5);
        font-size: 12px;
        color: #ffffff;
        height: 18px;
        line-height: 18px;
        border-radius: 3px;
        text-align: center;
      cursor: pointer;
        &:hover{
            background-color: rgba(237,64,64,.5);
        }
    }
    .imgbox{
        display: inline-block;
        width: 267px;
        height: 183px;
        font-size: 0;
      cursor: pointer;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .hot_time{
        display: inline-block;
        width: 149px;
        height: 20px;
        margin-top: 5px;
        font-size: 12px;
        color: #b2b2b2;
    }
    .viewNumber{
        display: inline-block;
        height: 20px;
        width: 50px;
        margin-top: 10px;
        font-size: 12px;
        color: #b2b2b2;
        text-align: right;
    }
    .viewStar{
        width: 50px;
    }
  .columnBoxInnner{
    overflow: hidden;
    text-align: center;
    background-color: #fff;
    height: 60px;
    line-height: 60px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {

    .columnlistBox{
      margin-top: 0;
    }
    .columnBoxInnner{
      width: 100%;
      overflow: hidden;
      overflow-x: auto;
      .columnBoxInnnerList{
        white-space: nowrap;
        padding: 0 20px;
      }
    }
    .centerBox{
      padding: 0 20px;
    }
    .centerBox .centerli:nth-child(3n){
      margin: 0 auto 20px;
    }
    .centerBox .centerli{
      margin: 0 auto 20px;
      display: block;
      width: 100%;
      height: auto;
    }
    .topColumnname{
      display: none;
    }
    .imgbox{
      width: 30%;
      height: 80px;
      vertical-align: top;
    }
    .centerBox .centerli .centerli_p{
      display: inline-block;
      padding-left: 0;
      width: 70%;
      box-shadow:none;
      border: none;
      height: auto;
      .titlename{
        padding-top: 0;
        margin-left: 5px;
      }
    }
    .hot_time{
      width: 110px;
      margin-left: 5px;
    }
    .viewNumber{
      width: 58px;
    }
  }
</style>
